<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <div class="title">{{title}}</div>
        <el-button class="glo_btnItems glo_bgcMainColor"
                         size="small"
                         @click="addCity()">新建
              </el-button>
              <el-button class="glo_btnItems glo_bgcMainColor"
                         size="small"
                         @click="deleteCity()">删除
              </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData_1"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isselection="true"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    ></mytable>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
    <my-dialog
      diaWidth="400px"
      dialogTitle="新增开单网点"
      :isShowDialog="isShowDialog"
      @handleCloseDia="isShowDialog =false"
      @diaCancelBtn="isShowDialog = false"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
      is-append
    >
        <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                remote
                v-model="cityName"
                :remote-method="getDestCities"
                :loading="destCityLoading"
                @change="changeDestCity"
                @clear="clearDestCity"
                style="width:100%;"
              >
                <el-option
                  v-for="(city, index) in destCitys"
                  :key="index"
                  :label="city.destCity"
                  :value="city.cityName"
                >
                  <span style="float: left">{{ city.destCity }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    city.adCode
                  }}</span>
                </el-option>
              </el-select>
    </my-dialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
export default {
  mixins: [tableListNew, exportjs,mixin_print],
  components: {
    paging,
    mytable,
    myDialog,
  },
  props:{
    transportLineId:{},
    type:{}
  },
  data() {
    return {
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "删除", //按钮名称
          methods: "deleteCity", //当前页面的方法
          param: 1, //自定义参数标记
        }
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: ["waybillNumber"],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据
      tableData_1:[],
      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "admin_transport_line_city_v5", //  页面标识
      reportFiledsNumber: "admin_transport_line_city_v5", // 动态 条件、表头
      activeName: "first",
      selectedId: "",
      selectedNumber: "",
      isShowDialog:false,
      cityName:'',
      // 目的城市
      destCitys: [],
      destCityLoading: false,
    };
  },
  updated() {},
  created() {},
  mounted() {
    this.getDestCities()
    this.getDetail();
  },
  activated() {},
  computed:{
    title(){
      return this.type == 1 ? '始发城市' : '到达城市'
    }
  },
  watch: {
    transportLineId:{
      handler(val){
        this.getDetail()
      }
    }
  },
  methods: {
    async getDetail() {
      if (!this.transportLineId) {
        return;
      }
      const res = await this.getData({
        transportLineId: this.transportLineId,
        cityType : this.type
      });
      this.tableData_1 = this.tableData;
    },
    addCity(){
      this.isShowDialog = true
    },
    deleteCity(row){
      if (!row && this.selectTableData.length == 0) {
        return;
      }
      if(!row){
        row = this.selectTableData[0]
      }
      row.operationType = "DEL";
      this.calc();
    },
    async getDestCities(keyword) {
      this.destCityLoading = true;
      const data = await this.$API.runList({
        number: "admin_dest_city_downlist",
        keyword,
      });
      this.destCitys = data;
      this.destCityLoading = false;
    },
    async clearDestCity() {
      this.getDestCities();
    },
    changeDestCity() {

    },
    calc() {
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType !== "DEL"
      );
    },
    diaConfirmBtn(){
      this.isShowDialog = false
      if(!this.cityName){
        return
      }
      const city = this.destCitys.filter(item=>item.cityName === this.cityName)[0]
      this.tableData.push({
            provinceName:city.provinceName,
            cityName:city.cityName,
            operationType:'ADD',
            transportLineId:this.transportLineId,
            type:this.type
        })
      this.calc()
      this.cityName = ''
    },
     getRows(){
        return this.tableData.map(item=>{
            return {
                ...item,
                operationType:item.operationType || "UNCHANGED"
            }
        })
    }
  },
};
</script>


<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .glo_btnList_left{
    display: flex;
    .title{
        font-size: 16px;
        font-weight: bolder;
    }
  }
}
</style>
